import React from "react";
import styled from "styled-components";
import { HEADER_KEYS, DATE_HEADER } from "../../../constants";

const Table = ({
  tableHeader,
  tableData,
  handleSelectData,
  height,
  selectedRow
}) => {
  // const onClickRow = index => {
  //   if (selectedRow !== undefined) setSelectedRow(index);
  // };
  const tableValue = (key, value) => {
    if (key === "primaryID") {
      return `${value.primaryName} \n(${value.primaryID})`;
    }
    if (key === "secondaryID") {
      return `${value.secondaryName} \n(${value.secondaryID})`;
    }

    return value[key];
  };
  return (
    <StyledTable>
      <TableHeader>
        {tableHeader.map((header, index) => (
          <RowItem key={index} flex={header.key === HEADER_KEYS.NO ? 1 : 2}>
            {header.label}
          </RowItem>
        ))}
      </TableHeader>
      <TableBody>
        {tableData &&
          tableData.map((data, index) => (
            <Row
              $isselected={selectedRow === index}
              color={data.color}
              key={index}
              onClick={() => handleSelectData(index)}
            >
              <RowItem>{index + 1}</RowItem>
              {tableHeader.map(
                (header, index) =>
                  data[header.key] &&
                  (DATE_HEADER.indexOf(header.key) !== -1 ? (
                    <RowItem key={index} flex={2}>
                      {data[header.key].slice(5)}
                    </RowItem>
                  ) : (
                    <RowItem key={index} flex={2} >
                      {tableValue(header.key, data)}
                    </RowItem>
                  ))
              )}
            </Row>
          ))}
      </TableBody>
    </StyledTable>
  );
};

export default Table;

const StyledTable = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff8c;
  overflow: hidden auto;
`;

const TableHeader = styled.div`
  /* padding: 6px; */
  display: flex;
  width: 100%;
  /* min-width: 40rem; */
  background-color: #212428;
  position: sticky;
  top: 0;
  padding: 1rem 0;
`;

const TableBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* min-width: 40rem; */
  color: black;
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  border-top: 1px solid lightgray;
  background-color: ${({ $isselected }) =>
    $isselected ? "lightgray" : "white"};
  color: ${({ color }) => (color ? color : "black")};
  padding: 0.5rem 0;
`;

const RowItem = styled.div`
  text-align: center;
  flex: ${({ flex }) => (flex ? flex : 1)};
  font-size: 1rem;
  font-weight: 600;
  padding: 8px 0px;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  white-space: pre-line;  // 이 줄을 추가
`;
